<template>
  <b-loading :is-full-page="true" :active="true"></b-loading>
</template>

<script>
import { mapActions } from 'vuex'
import AuthApi from '@/api/auth'
export default {
  name: 'EmailVerified',
  components: {},
  data() {
    return {
      loading: true
    }
  },
  created() {
    this.verifyEmail()
  },
  methods: {
    ...mapActions(['getUser']),
    verifyEmail() {
      debugger
      this.loading = true
      AuthApi.verifyEmail(this.$route.params.key)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Your email address has been verified',
            position: 'is-top',
            type: 'is-success'
          })
          this.getUser().then(() => {
            this.$router.push({ name: 'Home' })
            this.loading = false
          })
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error verifying email.',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
